export default __webpack_public_path__ + "static/media/unnamed.82896b11.webp";